import { Component, Inject, OnInit } from '@angular/core';
import { Porteur } from '../../shared/porteur';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-del-validation',
  templateUrl: './del-validation.component.html',
  styleUrls: ['./del-validation.component.scss']
})
export class DelValidationComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DelValidationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {porteur: Porteur}) { 
  }

  ngOnInit() {
  }

  valid(){
    this.dialogRef.close(true);
  }

  refuse(){
    this.dialogRef.close(false);
  }
}
